import { render } from "./AddPaymentEventForm.vue?vue&type=template&id=550aa9d2"
import script from "./AddPaymentEventForm.vue?vue&type=script&lang=js"
export * from "./AddPaymentEventForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__